import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Modal from 'react-modal'
import { ReactComponent as CloseIcon } from '../../../assets/images/cancel-status.svg'
import './style.css'
import NumberFormat from 'react-number-format'
import * as documentAction from '../../../redux/actions/document.detail.action'
import { DocumentDetailModel } from '../../../models/documentDetail'
import { Cash } from '../../../Pages/PaymentDetail/Cash'
import { CashPayIn } from '../../../Pages/PaymentDetail/cashPayIn'
import Cheque from '../../../Pages/PaymentDetail/CKC'
import CreditCard from '../../../Pages/PaymentDetail/CreditCard'
import { CKCPayIn } from '../../../Pages/PaymentDetail/CKC pay in'
import { FWDCKC } from '../../../Pages/PaymentDetail/FWD_CKC'
import { QRCode } from '../../../Pages/PaymentDetail/QRCode'
import { RootReducers } from '../../../redux/reducers'
import { ETR_STATUS } from '../../../constants'

export const AdditionalInfo: React.FC<{ item: DocumentDetailModel }> = ({ item }) => {
  const dispatch = useDispatch()
  const [isOpenModal, setIsOpenModal] = useState<boolean>(false)
  const documentData = useSelector((state: RootReducers) => state.documentDetailReducer)
  const handleModalClose = () => {
    setIsOpenModal(!isOpenModal)
  }
  const handleModalOpen = () => {
    setIsOpenModal(!isOpenModal)
  }
  const handleDialogSaveComplete = (form: any) => {
    handleModalClose()
    //console.log('aaaa')
    // refresh data

    item.documentID && dispatch(documentAction.handleGetDocumentById(item.documentID.toString()))
  }

  const renderPaymentDetail = () => {
    switch (item.paymentMethod.id) {
      case 1:
        return (
          <Cash
            data={item}
            documentId={item.id as number}
            setPaymentDetailFormValue={handleDialogSaveComplete}
          />
        )
      case 2:
        return (
          <Cheque
            form={item}
            documentId={item.id as number}
            setPaymentDetailFormValue={handleDialogSaveComplete}
          />
        )
      case 3:
        return (
          <CreditCard
            form={item}
            documentId={item.id as number}
            setPaymentDetailFormValue={handleDialogSaveComplete}
          />
        )
      case 5:
        return (
          <CashPayIn
            data={item}
            documentId={item.id as number}
            setPaymentDetailFormValue={handleDialogSaveComplete}
          />
        )
      case 6:
        return (
          <CKCPayIn
            paymentDetail={item}
            documentId={item.id as number}
            setPaymentDetailFormValue={handleDialogSaveComplete}
          />
        )
      case 7:
        return (
          <FWDCKC
            paymentDetail={item}
            documentId={item.id as number}
            setPaymentDetailFormValue={handleDialogSaveComplete}
          />
        )
      case 8:
        return (
          <QRCode
            label=""
            paymentDetail={item}
            documentId={item.id as number}
            setPaymentDetailFormValue={handleDialogSaveComplete}
          />
        )
      default:
        return <div>Oops! something went wrong</div>
        break
    }
  }
  return (
    <>
      <div className="flex-container">
        <div className="flex-item-left"></div>
        <div className="flex-item-right amount-right">
          {/* <div className="button-container">
            <button className="confirm-paid-button">ข้อมูลเพิ่มเติม</button>
          </div> */}
          <button
            className="confirm-paid-button"
            onClick={handleModalOpen}
            disabled={documentData.documentModel?.status !== ETR_STATUS.NEW_ETR}
            style={{ width: 'unset' }}
          >
            ข้อมูลเพิ่มเติม
          </button>
        </div>
      </div>

      <Modal
        isOpen={isOpenModal}
        className="modal-search"
        style={{
          overlay: {
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(24, 48, 40, 0.9)'
          }
        }}
        ariaHideApp={false}
      >
        <div className="modal-more-info-content">
          <div className="modal-more-info-header">
            <div className="modal-more-info-header-text">
              รายการข้อมูลการชำระเงินเพิ่มเติม {item.paymentMethod.name}
            </div>
            <div className="modal-more-info-header-icon">
              <div onClick={handleModalClose}>
                <CloseIcon />
              </div>
            </div>
            <div className="modal-popup-text">
              <div className="more-info-table"></div>
            </div>
          </div>
          <div>{renderPaymentDetail()}</div>
          <div className="more-info-data-notfound"></div>
        </div>
      </Modal>
    </>
  )
}
